import {
    cleanCommonParams,
    mapAttachmentsParams,
    mapContentParams,
    mapFeedItemParams,
    mapImageParams,
    mapPlatformsParams,
    mapProductsParams,
    mapSalesChannelsParams,
    mapStatesParams,
} from './common';

const mapCollateralParams = (
    isCreate,
    {
        attachments,
        categories,
        collateralCategories,
        content,
        feed_item,
        image,
        platforms,
        products,
        sales_channels,
        search_phrase_ids,
        states,
        ...params
    },
) => {
    return new Promise((resolve) => {
        const categoryIds = [].concat(collateralCategories);

        resolve({

            collateral: {
                role_type: 'agent',
                ...cleanCommonParams(params),
                ...mapAttachmentsParams(isCreate, attachments),
                ...mapContentParams(isCreate, content),
                ...mapFeedItemParams(isCreate, feed_item),
                ...mapImageParams(isCreate, image),
                ...mapPlatformsParams(isCreate, platforms),
                ...mapProductsParams(isCreate, products),
                ...mapSalesChannelsParams(isCreate, sales_channels),
                ...mapStatesParams(isCreate, states),
                category_ids: categoryIds,
                search_phrase_ids: search_phrase_ids || [],
            },
        });
    });
};

export { mapCollateralParams };
